"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanedStatsEffectHandler = exports.LoanedStatsEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class LoanedStatsEffectArgs {
    constructor(loanedAttributeScores) {
        this.loanedAttributeScores = loanedAttributeScores;
        this.__type = EffectType_1.EffectType.LoanedStats;
        this.__typeName = "LoanedStats";
        this.name = "Loaned Stats";
        this.harmful = false;
    }
}
exports.LoanedStatsEffectArgs = LoanedStatsEffectArgs;
let LoanedStatsEffectHandler = class LoanedStatsEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = [];
        sequence = sequence.pushSequence("parallel");
        for (const { attribute, score } of state.args.loanedAttributeScores) {
            state.meta.effectIds.push(container.applyBuff({
                sequence,
                creatorId: state.creatorId,
                targetId: state.targetId,
                effect: new _1.MaxAttributeIncreaseEffectArgs(attribute, score),
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
            }));
        }
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
LoanedStatsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.LoanedStats)
], LoanedStatsEffectHandler);
exports.LoanedStatsEffectHandler = LoanedStatsEffectHandler;
